var map = {
	"./building.vue": [
		"1a5c",
		"chunk-1bc4eadb"
	],
	"./company.vue": [
		"60f1",
		"chunk-575e903b",
		"chunk-3cf8c910"
	],
	"./contactus.vue": [
		"7865",
		"chunk-575e903b",
		"chunk-45bdd84b"
	],
	"./index.vue": [
		"1e4b",
		"chunk-575e903b",
		"chunk-1e794010",
		"chunk-516322b4"
	],
	"./news/details.vue": [
		"ea76",
		"chunk-575e903b",
		"chunk-b0204e56",
		"chunk-9d1ae19c"
	],
	"./news/index.vue": [
		"7c64b",
		"chunk-575e903b",
		"chunk-b0204e56",
		"chunk-4aae7e18"
	],
	"./product.vue": [
		"146f",
		"chunk-575e903b",
		"chunk-33e3831e"
	],
	"./productDetail.vue": [
		"2e1b",
		"chunk-575e903b",
		"chunk-1e794010",
		"chunk-fb24cab4"
	],
	"./recruit.vue": [
		"6f96",
		"chunk-575e903b",
		"chunk-7cfbafe8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;